import React from 'react'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import Proptypes from 'prop-types'
import { Grid, Typography } from '@mui/material'

const UserRow = ({ user, onClick }) => {

  function stringToColor() {
    const colors = ['#3a6daa', '#27417a']
    const randomIndex = Math.floor(Math.random() * 2)
    return colors[randomIndex]
  }

  const stringAvatar = (name) => {
    return {
      sx: {
        bgcolor: stringToColor(),
        marginTop: { md: '15px', xs: '20px' }, 
        width: { md: 72, sm: 64, xs: 56 }, 
        height: { md: 72, sm: 64, xs: 56 }
      },
      children: name ? `${name.split(' ')[0][0]}${name.split(' ')[1] ? name.split(' ')[1][0] : ''}` : '',
    }
  }
  
  return (
    <Box
      sx={{
        border: '1px solid #3A6DAA',
        marginBottom: '10px',
        height: '100px',
      }}
      component={Grid}
      container
      spacing={0}
    >
      <Grid
        item
        lg={1}
        xs={2}
        align="center"
      >
        <Avatar 
          {...stringAvatar(user?.displayName)}
        />
      </Grid>
      <Grid
        item
        container
        lg={11}
        xs={10}
        alignItems="center"
      >
        <Grid item xs={9}>
          <Typography
            component='span'
            sx={{
              textDecoration: 'underline',
              fontSize: '16px',
              color: '#27417A',
              cursor: 'pointer'
            }}
            onClick={onClick}
          >
            {user?.displayName}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              fontSize: '14px',
            }}
          >
            <div>{user?.mail}</div>
          </Box>
        </Grid>
        <Grid 
          item 
          xs={3} 
          container
          justifyContent='flex-end'
        >
          <Typography
            component='span'
            sx={{
              textDecoration: 'underline',
              fontSize: '12px',
              color: '#27417A',
              cursor: 'pointer',
              display: 'flex'
            }}
            onClick={onClick}
          >
                View / Edit User Profile
            <ChevronRightIcon />
          </Typography>
        </Grid>
      </Grid>
    </Box>
  )
}

UserRow.propTypes = {
  user: Proptypes.shape({
    displayName: Proptypes.string,
    mail: Proptypes.string
  }),
  onClick: Proptypes.func
}

export default UserRow